import styled from 'styled-components';

export const PanelStyled = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  overflow-y: auto;
  background-color: #333333;

  #SlideArea {
    position: relative;
    width: 100%;
    flex: 1;
  }
`;


export const SPImprintStyled = styled.div`
  padding-right: 20px;
  padding-bottom: 10px;

  display: grid;
  grid-template-columns: auto 40px;
  grid-template-rows: auto auto;
  grid-column-gap: 5px;

  > .FAButton {
    grid-column: 2;
    grid-row-start: 1;
    grid-row-end: 3;
  }

  > span {
    font-size: 10px;
    padding: 0px;
    margin: 0px;
    cursor: pointer;
    text-align: right;
    > u {
      color: #156EAC;
    }
  }
`;